import React from 'react';
import {
  Dialog,
  DialogContent,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
} from '@mui/material';
import { Stack } from '@mui/system';
import { QuestionSeenStats } from '../common/components/QuestionSeenStats';
import { QuestionStats } from '@par/shared/types/question-stats';

type PropTypes = {
  close: () => void;
  open: boolean;
  questionStats: QuestionStats;
};

export const LastSurvivalQuestionStatsDialog = ({
  close,
  open,
  questionStats,
}: PropTypes) => {
  return (
    <Dialog open={open} onClose={close} maxWidth="lg">
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack
          sx={{
            backgroundColor: '#271b0d',
            border: '1px solid #634343',
            borderRadius: '5px',
          }}
        >
          <QuestionSeenStats questionStats={questionStats} />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
